import React from 'react';

type Props = {
  isSelected: boolean;
  id: string;
  label: string;
  isDisabled?: boolean;
  title?: string;
  onClick: (event: React.MouseEvent, newKey: string) => void;
  postfixIconClass?: string;
};

const CustomTabHeader = (props: Props) => {
  const {
    isSelected,
    id,
    onClick,
    label,
    isDisabled = false,
    title,
    postfixIconClass,
    ...rest
  } = props;
  const tabClassNames = `custom-tab-header ${isSelected ? 'selected' : ''}`;
  return (
    <button
      disabled={isDisabled}
      onClick={(e) => onClick(e, id)}
      className={tabClassNames}
      title={title}
      data-testid={'custom-tab-header-' + id}
      {...rest}
    >
      {label}
      {postfixIconClass && (
        <i className={'postfix fa-light ' + postfixIconClass} />
      )}
    </button>
  );
};

export default CustomTabHeader;
